
import React, { Component } from 'react';
import Nav from './components/Nav';
import LoginForm from './components/LoginForm';
import SignupForm from './components/SignupForm';
import './Login.css';
import Grid from '@material-ui/core/Grid';
import SnackbarContent from "@material-ui/core/SnackbarContent";
import Snackbar from "@material-ui/core/Snackbar";
import { withStyles } from "@material-ui/core/styles";
import ErrorIcon from "@material-ui/icons/Error";
import CloseIcon from "@material-ui/icons/Close";
import classNames from "classnames";
import IconButton from "@material-ui/core/IconButton";
import decode from 'jwt-decode';

const variantIcon = {
  error: ErrorIcon,
};

const styles1 = theme => ({
  error: {
    backgroundColor: theme.palette.error.dark
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

class Login extends Component {
  constructor(props) {
    super(props);
    this.handleAlertClose = this.handleAlertClose.bind(this);
    this.state = {
      displayed_form: '',
      logged_in: localStorage.getItem('token') && !this.expired(localStorage.getItem('token')),
      username: '',
      alert: false,
    };
  }

  expired = (token) => {
    try {
      const decoded = decode(token);
      if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
          return true;
      }
      else
          return false;
    }
    catch (err) {
        return false;
    }
  }

  handleAlertClose = () => {
    this.setState({ alert: false });
  };

  componentDidMount() {
    if (this.state.logged_in) {
      fetch('https://api.medbase.xyz/login/current_user/', {
        headers: {
          Authorization: `JWT ${localStorage.getItem('token')}`
        }
      })
        .then(res => res.json())
        .then(json => {
          this.setState({ username: json.username });
        });
    }
  }

  handle_login = (e, data) => {
    e.preventDefault();
    fetch('https://api.medbase.xyz/token-auth/', {
      method: 'POST',
      mode: "cors",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(res => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('Post failed');
        }
      })
      .then(json => {
        localStorage.setItem('token', json.token);
        this.setState({
          logged_in: true,
          displayed_form: '',
          username: json.user.username
        });

      })
      .catch((error) => {
        this.setState({ alert: true });
        console.log("error", error)
      });
  };

  handle_signup = (e, data) => {
    e.preventDefault();
    fetch('https://api.medbase.xyz/login/users/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(res => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('Post failed');
        }
      }
      )
      .then(json => {
        localStorage.setItem('token', json.token);
        this.setState({
          logged_in: true,
          displayed_form: '',
          username: json.username
        });
      })
      .catch((error) => {
        this.setState({ alert: true });
        console.log("error", error)
      });
  };

  handle_logout = () => {
    localStorage.removeItem('token');
    this.setState({ logged_in: false, username: '' });
  };

  display_form = form => {
    this.setState({
      displayed_form: form
    });
  };

  render() {
    let form, header;

    switch (this.state.displayed_form) {
      case 'login':
        form = <LoginForm handle_login={this.handle_login} />;
        header='Log In to Pillnotes';
        break;
      case 'signup':
        form = <SignupForm handle_signup={this.handle_signup} />;
        header='Create a Pillnotes Account';
        break;
      default:
        form = <LoginForm handle_login={this.handle_login} />;
        header='Log In to Pillnotes';
        break;
    }
    

    return (
      <div>
        <div className="space-header"></div>

        <Snackbar
            open={this.state.alert}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            autoHideDuration={5000}
            onClose={this.handleAlertClose}
          >
            <MySnackbarContentWrapper
              onClose={this.handleAlertClose}
              variant="error"
              message="Error"
            />
     </Snackbar>
        <Grid container justify="center" alignItems="center">
          <Grid item xs={3.5} />
          <Grid item xs={5} className="form-content">
            {!this.state.logged_in
              ? <div className='title'>
                  {header}
                </div>
              : <div className='title'>
                  <div> {`Hello, ${this.state.username}`}</div>
                  <div> {`You are currently logged in.`} </div>
                  <div className="space-20" />
                  <div> 
                    {`Click `}
                    <a href="/psychiatry">
                        here
                    </a> 
                    {` to view psychiatry cards.`}
                  </div>
                </div>
            }
          </Grid>
          <Grid item xs={3.5}></Grid>
        </Grid>

        <Grid container justify="center" alignItems="center">
          <Grid item xs={3.5} />
          <Grid item xs={5} className="form-content">
            <Nav
                logged_in={this.state.logged_in}
                display_form={this.display_form}
                displayed_form={this.state.displayed_form}
                handle_logout={this.handle_logout}
              />          </Grid>
          <Grid item xs={3.5}></Grid>
        </Grid>
        
        
        {!this.state.logged_in
          ? form
          : null
        }



        <Grid container justify="center" alignItems="center">
          <Grid item xs={3.5} />
          <Grid item xs={5} className="form-content">
            <div className="return">
                <a href="/"  className="return-content">
                  Return to Home
                </a>
              </div>
            </Grid>
          <Grid item xs={3.5}></Grid>
        </Grid>
      </div>
    );
  }
}

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
}

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);
export default Login;


// WEBPACK FOOTER //
// ./src/Login.js